import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequirementService } from '@/services/requirement/requirement.service';
import { deofuscate } from '@/utils/obfuscation';

@Component({
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css'],
})
export class SuccessComponent implements OnInit {

  email: string = '';
  infractionId: string = '';

  constructor(
    public route: ActivatedRoute,
    public requirementService: RequirementService,
  ) { }

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);

      this.email = params.email;
      this.infractionId = params.infractionId;

    });
  }

}
